import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPerubahanModalService = new CrudCustom('/transaksi-perubahan-modal');
export default TransaksiPerubahanModalService;
